import {
  MutationTuple,
  useMutation,
  DocumentNode,
  OperationVariables,
} from '@apollo/client';
import { get } from 'lodash';
import logger from '../../helpers/logger/logger';

export const useMutationHelper = <
  TData = unknown,
  TVariables = OperationVariables,
>(
  mutation: DocumentNode,
  variables = {} as TVariables,
): MutationTuple<TData, TVariables> => {
  return useMutation<TData, TVariables>(mutation, {
    variables,
    onError: (error) => {
      const mutationBody = get(mutation, 'loc.source.body', '');

      logger.logError(
        'useMutationHelper',
        `Error executing mutation ${mutation} with body ${JSON.stringify(
          mutationBody,
        )}`,
        error,
      );
    },
  });
};
